import React from 'react'
// @ts-ignore no types
import { Text, ScrollSpy } from '@adc/ui-adc'
import * as graph from '@adc/sdk'
import type { AuctionBlueprintLiveReactiveArgs } from '@adc/blueprint'
import { usePropertyContext } from 'common/context/property'
import AuctionDetailsTemplate, {
  similarPropertiesLink,
  EstCreditBidNotExceeded,
  SavePropertyButton,
} from '../template'
import hasSimilarProperties from '../../../utils/hasSimilarProperties'
import { SAVE_PROPERTY_CTA_TPS } from '../../../statics'
import {
  CombinedListingType,
  ShortenedOnlineSegmentType,
  useListingContext,
} from '../../../context/listing'
import { getERVRow } from './common'

const isTpsAuctionPendingSaleConfirmation = (
  listing: CombinedListingType,
  segment: ShortenedOnlineSegmentType
) => {
  return (
    listing.listing_configuration?.asset_type ===
      graph.enums.AssetType.Foreclosure &&
    segment?.segment_status === graph.enums.OnlineAuctionSegmentStatus.Ended &&
    [
      graph.enums.ListingStatus.SaleGatekeeping,
      graph.enums.ListingStatus.SalePaymentPending,
    ].includes(listing.listing_status)
  )
}

interface detailContentProps {
  listing: CombinedListingType
  segment:
    | ShortenedOnlineSegmentType
    | AuctionBlueprintLiveReactiveArgs['segment']
  isRedesignEnabled?: boolean
}

const detailContent = ({ listing, isRedesignEnabled }: detailContentProps) => {
  const details = [
    {
      label: listing.listing_status === graph.enums.ListingStatus.Canceled && ( // was bStatus.isAuctionCancelled
        <Text color='gray' data-elm-id='property_cancelled'>
          Property has been Canceled
        </Text>
      ),
    },
  ]
  const ervRow = getERVRow(listing, isRedesignEnabled)
  ervRow && details.unshift(ervRow)
  return details
}

interface AdditionalContentProps {
  similarProperties?: any[]
  listing: CombinedListingType
  segment: ShortenedOnlineSegmentType
}

const additionalContent = ({
  listing,
  segment,
  similarProperties,
}: AdditionalContentProps) => (
  <div>
    {isTpsAuctionPendingSaleConfirmation(listing, segment) && ( // was bStatus.isAuctionPendingSaleConfirmation
      <ScrollSpy selector='#prepare_your_finances'>
        {({ scrollTo }: { scrollTo?: () => void }) => (
          <Text className='u-mt-2'>
            <a onClick={scrollTo} data-elm-id='prepare_for_auction_cta'>
              Prepare for auction
            </a>
          </Text>
        )}
      </ScrollSpy>
    )}
    {similarPropertiesLink({
      listing,
      isButton: !isTpsAuctionPendingSaleConfirmation(listing, segment),
      hasSimilarProperties: hasSimilarProperties(similarProperties),
    })}
    {/* was !bStatus.isAuctionPendingSaleConfirmation */}
    <div className='u-mt-2'>
      {listing.auction?.auction_status === graph.enums.AuctionStatus.NoSale && (
        <EstCreditBidNotExceeded />
      )}{' '}
      {/* was: bStatus.isAuctionSoldToLender  */}
    </div>
  </div>
)

interface AfterTPSProps {
  similarProperties: any[]
  isRedesignEnabled?: boolean
}

const AfterTPS = ({ similarProperties, isRedesignEnabled }: AfterTPSProps) => {
  const { property, propertyActions } = usePropertyContext()
  const { listing, segment } = useListingContext()

  let auctionStatus
  if (isTpsAuctionPendingSaleConfirmation(listing, segment))
    auctionStatus = 'Pending'
  // was bStatus.isAuctionPendingSaleConfirmation
  else if (listing.listing_status === graph.enums.ListingStatus.Canceled)
    auctionStatus = 'Canceled'
  // was bStatus.isAuctionCancelled
  else auctionStatus = 'Ended'

  return (
    <AuctionDetailsTemplate
      title={`Sale - ${auctionStatus}`}
      primaryButton={
        isTpsAuctionPendingSaleConfirmation(listing, segment) && (
          <SavePropertyButton
            listing={listing}
            property={property}
            isSaved={property.is_currently_saved}
            actions={propertyActions}
            options={{
              text: SAVE_PROPERTY_CTA_TPS,
            }}
          />
        )
      }
      additionalContent={additionalContent({
        listing,
        segment,
        similarProperties,
      })}
      detailContent={detailContent({ listing, segment, isRedesignEnabled })}
    />
  )
}

export default AfterTPS
